import React, {useContext, useState, useEffect} from "react";
import Modal from "../../../containers/Modal";
import {Input, SelectStyled} from "../../../styles/Forms";
import {Grid, Col} from "../../../styles/Grid";
import styled from "styled-components";
import {FacilitatorsContext} from "../../../context/FacilitatorsProvider";
import {Label} from "../../../components/forms/DynamicInput";
import EditableImg from "../../../components/forms/EditableImg";
import {AppButton} from "../../../styles/Butttons";
import {CreateFacilitatorService} from "../../../services/FacilitatorsService";
import AppLoader from "../../../components/loaders/Loader";
import SuccesModal from "../../../components/modals/SuccessModal";
// import {ReactComponent as CancelIcon} from "../../../assets/icons/cancel.svg";

export default function AddFacilitatorModal({isOpen, close, theme}) {
   const {addFacilitator} = useContext(FacilitatorsContext);
   const [showSuccess, setSuccess] = useState(false);
   const [isSavingData, setLoader] = useState(false);

   useEffect(() => {
      setSuccess(false);
      setLoader(false);
   }, [isOpen]);

   const SaveUser = e => {
      e.preventDefault();
      setLoader(true);
      const formda = e.target;
      // console.log(formda);
      let newFacilitator = new FormData();
      newFacilitator.append("token", localStorage.getItem("domecq_token"));
      newFacilitator.append("idFacilitatorArea", formda.idFacilitatorArea.value);
      newFacilitator.append("facilitatorName", formda.facilitatorName.value);
      newFacilitator.append("facilitatorLastName", formda.facilitatorLastName.value);
      newFacilitator.append("biography", formda.biography.value);
      newFacilitator.append("shortDescription", formda.shortDescription.value);
      newFacilitator.append("phone", formda.phone.value);
      // images
      newFacilitator.append("pathImageBioMobile", formda.biographyM.files[0]);
      newFacilitator.append("pathImageBioDesktop", formda.biographyD.files[0]);
      newFacilitator.append("pathImageWebDesktop", formda.profileImg.files[0]);
      newFacilitator.append("pathImageWebMobile", formda.profileImg.files[0]);
      // console.log(formda.name.value, formda.speciality.value);
      CreateFacilitatorService(newFacilitator)
         .then(res => res.json())
         .then(resp => {
            const {data, status} = resp;
            console.log("resp", resp);
            if (status === "error") throw new Error();
            const toAdd = {
               ...data,
               name: data.facilitatorName + " " + data.facilitatorLastName,
               biography: formda.biography.value,
            };
            setSuccess(true);
            setLoader(false);
            // addFacilitator(newFacilitator);
         })
         .catch(e => {
            console.log(e);
            setLoader(false);
         });
   };

   return (
      <>
         <Modal
            isOpen={isOpen}
            close={() => {
               close();
            }}
            size="big"
            theme={theme}
            showSuccess={showSuccess}
            title="NUEVO FACILITADOR"
         >
            <DivModal>
               <form onSubmit={SaveUser}>
                  <Grid>
                     <Col large={3}>
                        <Label>Nombre:</Label>
                        <Input type="text" name="facilitatorName" />
                     </Col>
                     <Col large={3} offsetL={1}>
                        <Label>Apellido:</Label>
                        <Input type="text" name="facilitatorLastName" />
                     </Col>
                     <Col large={4} offsetL={1}>
                        <Label>Especialidad:</Label>
                        <Input type="text" name="shortDescription" />
                     </Col>
                     <Grid className="maxMargin">
                        <Col large={5}>
                           <Label>Área:</Label>
                           <SelectStyled name="idFacilitatorArea">
                              <option value={1}>Vino</option>
                              <option value={2}>Barra</option>
                           </SelectStyled>
                        </Col>
                        <Col large={5} offsetL={1}>
                           <Label>Teléfono:</Label>
                           <Input type="phone" name="phone" />
                        </Col>
                     </Grid>
                     <Col large={12} className="maxMargin">
                        <Label>Biografía: </Label>
                        <TextArea as="textarea" name="biography" />
                     </Col>
                  </Grid>
                  <Grid className="maxMargin">
                     <Col large={8} className="imgInput">
                        <EditableImg label="Imágen Página Facilitadores Medidas aprox 259px  259px" editable={true} name="profileImg" />
                     </Col>
                     <Col large={12} className="maxMargin">
                        <Label>Imágen de biografía: </Label>
                        <Grid className="minMargin">
                           <Col large={6} className="imgInput">
                              <EditableImg
                                 //  value={} change={}
                                 label="Desktop medidad aprox 1024px x 763px"
                                 editable={true}
                                 name="biographyD"
                              />
                           </Col>
                           <Col large={6} className="imgInput">
                              <EditableImg
                                 //  value={} change={}
                                 label="Mobile medidas aprox 510px X 428px"
                                 editable={true}
                                 name="biographyM"
                              />
                           </Col>
                        </Grid>
                     </Col>
                  </Grid>
                  <Grid className="minMargin">
                     <Col large={3} offsetL={9}>
                        <AppButton>Guardar</AppButton>
                     </Col>
                  </Grid>
               </form>
            </DivModal>
            <AppLoader isVisible={isSavingData} />
         </Modal>
         {/* <SuccesModal /> */}
      </>
   );
}

const DivModal = styled.div`
   .buttonModal {
      margin-top: 2em;
   }
   .maxMargin {
      margin-top: 2em;
   }
   .minMargin {
      margin-top: 1em;
   }
   & ${Input}, & ${SelectStyled} {
      margin: 0;
   }

   & .imgInput {
      // width: 100%;
      & .row {
         width: 100%;

         .label {
            font-size: 0.8em;
         }
      }
   }
`;

const TextArea = styled(Input)`
   width: 100%;
   font-family: "Montserrat", sans-serif;
   height: 100px;
   resize: none;
`;
